import { nextTick } from 'process'
import { Component, Vue } from 'vue-property-decorator'
import {
  scrollToDivElementBeforeLogin,
  fixedContentNoLogin
} from '@/assets/js/main.js'
import OtherUrlConstants from '@/common/OtherUrlConstants'
@Component({
  name: 'CAAG1030',
  components: {}
  })
export default class CAAG1030Controller extends Vue {
  private scrollToDivElement = scrollToDivElementBeforeLogin
  /**
   * 画面要素描画後処理
   */
  mounted() {
    this.init()

    nextTick(() => {
      fixedContentNoLogin()
    })
  }

  /**
   * 初期処理
   */
  private init() {}

  /**
   * コールセンターを行う。
   * @param phoneNumber 電話番号
   */
  private callCenter(phoneNumber: string) {
    window.open('tel:' + phoneNumber, '_self')
  }

  /**
   * JIS&Tログイン画面に遷移する。
   */
  private gotoLoginJIST() {
    window.open(OtherUrlConstants.JIST_LOGIN, '_blank')
  }

  /**
   * ログイン画面への遷移
   */
  private gotoCAAG1010() {
    this.$router.push({ name: 'caag1010' })
  }
}
